/* tslint:disable:interface-name */
declare interface String {
  toLowerCaseFirstLetter(): string
}

String.prototype.toLowerCaseFirstLetter = function () {
  return String(this).charAt(0).toLocaleLowerCase() + String(this).slice(1)
}
